module.exports = __webpack_public_path__ + "img/zd-new-1.7535cf08.svg";